'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _menu = require('material-ui/lib/menus/menu');

var _menu2 = _interopRequireDefault(_menu);

var _menuItem = require('material-ui/lib/menus/menu-item');

var _menuItem2 = _interopRequireDefault(_menuItem);

var _divider = require('material-ui/lib/divider');

var _divider2 = _interopRequireDefault(_divider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryMenu = function (_Component) {
  _inherits(BinaryMenu, _Component);

  function BinaryMenu(props) {
    _classCallCheck(this, BinaryMenu);

    var _this = _possibleConstructorReturn(this, (BinaryMenu.__proto__ || Object.getPrototypeOf(BinaryMenu)).call(this, props));

    _this.styles = require('./BinaryMenu.scss');
    _this.state = {
      open_item: false,
      current_menu: null
    };
    return _this;
  }

  _createClass(BinaryMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currentMenu = '';
      if (this.state.current_menu === null) {
        if (nextProps.current) {
          currentMenu = nextProps.current;
        } else {
          currentMenu = nextProps.data ? nextProps.data[0].text : null;
        }
        this.setState({ current_menu: currentMenu });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(data) {
      this.setState({
        current_menu: data.text
      });
      this.props.onChange(data.text, data.pannel);
    }
  }, {
    key: 'getUnderline',
    value: function getUnderline(index) {
      return _react2.default.createElement(_divider2.default, {
        className: this.styles.binary_menu_divider,
        key: index
      });
    }
  }, {
    key: 'getMenuItem',
    value: function getMenuItem() {
      var _this2 = this;

      var data = this.props.data;

      var DATA = [];
      var NESTEDDATA = [];
      if (data) {
        data.forEach(function (menuItem, index) {
          var key = menuItem.text.split(' ').join('_').toLowerCase();
          if (menuItem.children === null) {
            DATA.push(_react2.default.createElement(_menuItem2.default, {
              onTouchTap: _this2.onChange.bind(_this2, menuItem),
              className: _this2.styles.binary_menu_item,
              key: key,
              value: menuItem.text,
              style: { fontSize: '1em' },
              primaryText: _react2.default.createElement(
                'div',
                null,
                menuItem.icon ? menuItem.icon : '',
                menuItem.text
              ) }));
          } else {
            NESTEDDATA = _this2.getNestedItem(menuItem);
            DATA = DATA.concat(NESTEDDATA);
          }
          if (data.length !== 1) {
            DATA.push(_this2.getUnderline(index));
          }
        });
      }

      return DATA;
    }
  }, {
    key: 'getNestedItem',
    value: function getNestedItem(menuItem) {
      var _this3 = this;

      var key = menuItem.text.split(' ').join('_').toLowerCase();
      var DATA = [];
      var children = [];
      menuItem.children.forEach(function (childrenItem, childrenIndex) {
        var childKey = childrenItem.text.split(' ').join('_').toLowerCase();
        var style = { fontSize: '1em', paddingLeft: '10px', lineHeight: '30px' };
        if (_this3.state.open_item) {
          style.display = 'inherit';
        } else {
          style.display = 'none';
        }
        children.push(_react2.default.createElement(_menuItem2.default, {
          onTouchTap: _this3.onChange.bind(_this3, childrenItem),
          className: _this3.styles.binary_menu_item_child,
          key: childKey + '_' + childrenIndex,
          value: childrenItem.text,
          ref: 'menuitem',
          style: style,
          primaryText: _react2.default.createElement(
            'div',
            null,
            menuItem.icon ? menuItem.icon : '',
            childrenItem.text
          )
        }));
      });
      DATA.push(_react2.default.createElement(_menuItem2.default, {
        onTouchTap: function onTouchTap() {
          _this3.setState({ open_item: !_this3.state.open_item });
        },
        className: this.styles.binary_menu_item,
        key: key,
        value: menuItem.text,
        style: { fontSize: '1em' },
        primaryText: _react2.default.createElement(
          'p',
          { style: { margin: '0px' } },
          _react2.default.createElement(
            'span',
            null,
            menuItem.icon ? menuItem.icon : '',
            menuItem.text
          ),
          _react2.default.createElement('i', { className: 'fa fa-caret-down', style: { marginLeft: '10px', color: '#000 !important' } })
        )
      }));
      if (this.state.open_item) {
        DATA.push(this.getUnderline('divider_' + key));
      }
      DATA.push(children);
      return DATA;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = this.props.style;

      style.width = style.width ? style.width : '100%';

      return _react2.default.createElement(
        _menu2.default,
        {
          style: style,
          className: this.styles.binary_menu,
          desktop: true,
          useLayerForClickAway: false,
          value: this.state.current_menu,
          selectedMenuItemStyle: { backgroundColor: '#F5F4FF', color: '#000' }
        },
        this.getMenuItem()
      );
    }
  }]);

  return BinaryMenu;
}(_react.Component);

BinaryMenu.propTypes = {
  onChange: _propTypes2.default.func,
  style: _propTypes2.default.object,
  current: _propTypes2.default.string,
  data: _propTypes2.default.array // {text: children: pannel: icon: }
};
BinaryMenu.defaultProps = {
  data: []
};
exports.default = BinaryMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryMenu/BinaryMenu.js
// module id = 2242
// module chunks = 1